export default "__VITE_ASSET__374010d0__"